<template>
  <div>
    <Row type="flex" justify="center">
      <Col>
        <h3 style="color:#893448;font-size:18px;letter-spacing:0.4px;white-space: nowrap;">{{ table_title }}</h3>
      </Col>
    </Row>
    <Row>
      <Col span="24">
        <Tabs v-model="current_tabs_name" type="card" name="tab1">
          <TabPane :label="tabs_label1" name="name1" tab="tab1">
            <Row type="flex" align="middle">
              <Col offset="23" span="1">
                <Tooltip transfer content="刷新当前预警策略" :delay="1500">
                    <Button style="font-size:20px;color:#0099FF;box-shadow:none" type="text" size="large" 
                      shape="circle" icon="md-refresh" :loading="this.loop_update_er_overview_loading"
                      @click="this.loop_update_er_overview_click"
                    ></Button>
                </Tooltip>
              </Col>
            </Row>
            <Row>
              <v-table
                :title="this.er_overview_title"
                :title_info="this.er_overview_info"
                :table_columns="this.er_overview_columns"
                :table_data="this.er_overview_data"
                :table_ref="this.er_overview_ref"
                :max_height="750"
                :init_table="this.er_overview_init_table_func"
                :table_name_array="this.er_overview_array"
                :show_top="false"
                :show_page="false"
              ></v-table>
            </Row>
          </TabPane>
          <TabPane :label="tabs_label2" name="name2" tab="tab1">
            <Row type="flex" justify="center" align="middle">
              <Col offset="20">
                <v-early-report-render-dropdown-view
                  :_type="0"
                  :allow_msg="this.all_early_report_data"
                  :drop_down_title="this.er_status_drop_down_title"
                  v-on:dropdown_click="early_report_render_dropdown_click"
                  :icon_flag="false"
                ></v-early-report-render-dropdown-view>
              </Col>
              <Col >
              <Tooltip transfer content="刷新当前状态" :delay="1500">
                  <Button style="font-size:20px;color:#0099FF;box-shadow:none" type="text" size="large" 
                    shape="circle" icon="md-refresh" :loading="this.loop_update_current_er_status_loading"
                    @click="this.loop_update_current_er_status_click"
                  ></Button>
              </Tooltip>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <v-table
                  :title="this.er_status_title"
                  :title_info="this.er_status_info"
                  :table_columns="this.er_status_columns"
                  :table_data="this.er_status_data"
                  :table_ref="this.er_status_ref"
                  :max_height="700"
                  :init_table="this.er_status_init_table_func"
                  :table_name_array="this.er_status_array"
                  :show_top="false"
                  :show_page="false"
                  :stripe="true"
                  :table_page_size="100"
                  :span_method="er_status_handle_span"
                ></v-table>
            </Col>
            </Row>
          </TabPane>
          <TabPane :label="tabs_label3" name="name3" tab="tab1">
            <Row type="flex" justify="center">
                  <h3 style="color:#893448;font-size:13px;letter-spacing:0.4px;white-space:nowrap;">{{ er_setting_title }}
                </h3>
            </Row>
            <Row style="height:8px;"></Row>
            <Row type="flex" justify="center" align="top">
              <Col span="8">
                  <Transfer
                    reverse-operation
                    :list-style="er_setting_2_title_list_style"
                    filterable
                    :titles="er_setting_1_titles"
                    filter-placeholder=""
                    :filter-method="er_setting_1_filter_method"
                    :data="er_setting_1_data"
                    :target-keys="er_setting_1_target_keys"
                    @on-change="er_setting_1_change"
                    >
                  </Transfer>
              </Col>
              <Col span="15">
                <div >
                  <v-early-report-render-modal-view
                    :paras="modal_view_msg.paras"
                    :open_modal_switch="modal_view_msg.open_modal_switch"
                    :uuid="modal_view_msg.uuid"
                    :modal_type="modal_view_msg.modal_type"
                    v-on:modal_click="modal_click"
                  >
                  </v-early-report-render-modal-view>
                  <Row type="flex" justify="end">
                    <Col offset=22 span=2>
                      <v-early-report-render-dropdown-view
                        :_type="1"
                        :allow_msg="all_index"
                        drop_down_title="添加"
                        v-on:dropdown_click="early_report_render_dropdown_click"
                        :icon_flag="true"
                      ></v-early-report-render-dropdown-view>
                    </Col>
                  </Row>
                  <Row style="height:3px;"></Row>
                  <Row>
                  <v-table
                      :title="er_setting_2_title"
                      :title_info="er_setting_2_info"
                      :table_columns="er_setting_2_columns"
                      :table_data="er_setting_2_data"
                      :table_ref="er_setting_2_ref"
                      :max_height="550"
                      :init_table="er_setting_2_init_table_func"
                      :table_name_array="er_setting_2_array"
                      :show_top="false"
                      :show_page="false"
                      :table_page_size="100"
                    ></v-table>
                    </Row>
                  <Row style="height:15px;"></Row>
                  <Row type="flex" justify="end">
                    <Col offset="12" span="4">
                      <Button type="success" shape="circle" size="large" @click="er_setting_2_button_load_id">录入ID</Button>
                    </Col>
                    <Col span="4">
                      <Button type="success" shape="circle" size="large" 
                        :loading="er_setting_2_button_loading" @click="er_setting_2_button_submit">{{ er_setting_2_button_submit_text}}</Button>
                    </Col>
                  </Row>
                  </div>
                </Col>
            </Row>
          </TabPane>
        </Tabs>
      </Col>
    </Row>
  </div>
</template>

<script>
import table_view from "../components/TableView.vue";
import early_report_render_dropdown_view from "../components/EarlyReport/DropdownRender.vue";
import early_report_render_modal_view from "../components/EarlyReport/ModalRenderSign.vue";
import render_table_view from '../components/EarlyReport/TableRender.vue';
//import func from 'vue-editor-bridge';

export default {
  name: "tools_early_report_major",
  components: {
    "v-table": table_view,
    "v-early-report-render-dropdown-view":early_report_render_dropdown_view,
    "v-early-report-render-modal-view":early_report_render_modal_view,
  },
  data() {
    return {
      timer: null,
      table_title: "预警平台",
      tabs_label1: "总览",
      tabs_label2: "预警状态",
      tabs_label3: "设置页面",
      current_tabs_name: "name1",
      er_setting_1_titles:["可预警标的", "已预警标的"],
      // 当前选择的，用来在前端展示预警状态的预警id
      current_er_status_id:null,
      prefix:"early_report_",
      // 预警状态页的筛选项, 在填充数据后增加
      current_er_status_filters:[],
      // 存储上次获得symbol_list的时间
      last_timestamp_get_symbol_list:new Date().getTime(),
      // 存储所有可用的标的
      symbol_list:[],
      // 初始化modal的变量
      modal_view_msg: {
        "paras":[],
        "open_modal_switch":false,
        "uuid":"",
        "modal_type":""
      },

      loop_update_er_overview_loading:false,
      all_early_report_data:[],
      all_index:{},
      er_overview_init_table_func_start_loading:[],
      er_overview_init_table_func_stop_loading:[],
      er_overview_title: "",
      er_overview_info: [],
      er_overview_columns: [],
      er_overview_data: [],
      er_overview_ref: "er_overview_ref",
      er_overview_array: [
        "预警ID",
        "名称",
        "标的池",
        "预警指标池",
        "操作",
        "删除",
      ],

      loop_update_current_er_status_loading:false,
      er_status_drop_down_title:"选择预警ID",
      er_status_title: "",
      er_status_info: [],
      er_status_columns: [],
      er_status_data: [],
      er_status_ref: "er_status_ref",
      er_status_array: [
        "标的",
        "算法名",
        "指标名",
        "指标值",
      ],

      er_setting_1_data:[],
      er_setting_1_target_keys:[],

      er_setting_current_id:"-1",
      er_setting_title:"创建新的预警",
      er_setting_2_button_submit_text:"确认创建",
      er_setting_2_button_loading:false,
      er_setting_2_title: "",
      er_setting_2_info: [],
      er_setting_2_columns: [],
      er_setting_2_data: [],
      er_setting_2_ref: "er_setting_2_ref",
      er_setting_2_array: [
        "选择算法",
        "预警指标名",
        "预警指标参数",
        "操作"
      ],
      er_setting_2_title_list_style: {
          minWidth: '200px',
          height: '500px'
      }
    };
  },
  methods: {
    setTimer: function(interval) {
      if (this.timer == null) {
        this.timer = setInterval(() => {
            this.loop_update_er_overview_click()
            this.loop_update_current_er_status_click()
        }, interval);
      }
    },
    // 刷新总览页面，填充数据
    update_early_report_table_msg: function() {
      this.er_overview_data = []
      this.er_overview_init_table_func_start_loading = []
      this.er_overview_init_table_func_stop_loading = []
      for (var i = 0; i < this.all_early_report_data.length; i++) {
        this.er_overview_data.push(
          [this.all_early_report_data[i][0], this.all_early_report_data[i][1],
          this.all_early_report_data[i][2].join(", "), this.all_early_report_data[i][3].join("\n"),
          this.all_early_report_data[i][4]]
        )
        this.er_overview_init_table_func_start_loading.push(false)
        this.er_overview_init_table_func_stop_loading.push(false)
      }
    },
    // 刷新状态页面，填充数据
    update_early_status_table_msg: async function() {
      let er_status_data = []
      if (this.current_er_status_id == null) {
        this.er_status_drop_down_title = "选择预警ID"
        return null
      }
      var data_index = await this.get_supervisor_strategy_msg(this.current_er_status_id)
      if (Object.keys(data_index).length == 0) {
        this.er_status_drop_down_title = this.current_er_status_id + "号预警策略"
        return null
      }

      for (var i in this.all_early_report_data) {
        if (this.all_early_report_data[i][0].toString() == this.current_er_status_id.toString()) {
          var report_data = this.all_early_report_data[i]
          break
        }
      }

      var symbols = report_data[2]
      var indexs = report_data[3]
      var er_status_filters = []
      for (var i = 0; i < symbols.length; i++) {
        var symbol = symbols[i]
        er_status_filters.push({
          label: symbol,
          value: symbol,
        })
        for (var j = 0; j < indexs.length; j++) {
          // 算法id, 算法名, 是否开启预警, 预警参数, 这条预警信息的uuid编号
          //"-1_MA-1_66-490-3_f_buy_08716b92-f710-4d66-a170-06f089f611e0"
          var index = indexs[j].split("_")
          //"标的", "算法名", "指标名", "指标值"
          er_status_data.push([
            symbol, this.all_index[index[0].toString()][0], index[1],
            data_index[index[5]][symbol]
          ])
        }
        // 添加一个空行, 用来间隔数据
        er_status_data.push([symbol + "_defalut", "", "", ""])
      }
      this.er_status_data = er_status_data
      // 筛选方法动态加载
      this.er_status_columns[0]["filters"].length = 0;
      this.er_status_columns[0]["filters"] = er_status_filters
      // 指导合并单元格
      this.er_status_update_span_method(this.er_status_data)
      this.er_status_drop_down_title = this.current_er_status_id + "号预警策略"
    },
    // 刷新设置页面, 填充数据
    update_early_setting_table_msg: async function() {
      await this.get_all_useable_symbol_list()
      // 先处理穿梭框数据
      this.er_setting_1_data = []
      this.er_setting_1_target_keys = []
      for (var i in this.symbol_list) {
        this.er_setting_1_data.push(
          {key:this.symbol_list[i], label:this.symbol_list[i]}
        )
      }
      if (this.er_setting_current_id.toString() != "-1") {
        for (var i in this.all_early_report_data) {
          if (this.all_early_report_data[i][0].toString() == this.er_setting_current_id.toString()) {
            var symbols = this.all_early_report_data[i][2]
            for (var j in symbols) {
              this.er_setting_1_target_keys.push(symbols[j])
            }
            break
          }
        }
      }

      this.er_setting_2_data = []
      // 再处理表格数据
      if (this.er_setting_current_id.toString() == "-1") {
        // 创建新预警：表格填充所有可选算法
        for (var key in this.all_index) {
          var name = this.all_index[key][1].split("_")[1]
          this.er_setting_2_data.push([
            this.all_index[key][0], name, this.all_index[key][1] + "_" + this.get_uuid(), key
          ])
        }
      } else {
        for (var i in this.all_early_report_data) {
          if (this.all_early_report_data[i][0].toString() == this.er_setting_current_id.toString()) {
            var indexs = this.all_early_report_data[i][3]
            for (var j in indexs) {
              var con = indexs[j].split("_")
              this.er_setting_2_data.push([
                this.all_index[con[0].toString()][0], con[1], indexs[j], con[0]
              ])
            }
            break
          }
        }
      }
      this.early_setting_table_msg_sorted()
    },
    // 对设置页面表格进行排序
    early_setting_table_msg_sorted: function() {
      this.er_setting_2_data.sort(function(a, b){return Number(a[3]) - Number(b[3])})
    },
    // 获得所有可用的symbol集合
    get_all_useable_symbol_list: async function(){
      // 获得展示在灵活策略Flexible上标的列表
      if ((new Date().getTime() - this.last_timestamp_get_symbol_list > 600 * 1000) || 
          (this.symbol_list.length == 0)) {

          let axios_symbol_list = []
          let data = await this.$axios.get(
              this.$store.state.urlPort + "/flexible_strategy",
              {
                params: {
                  mode: "get_flexible_symbol_list",
                }
              }
            )
          if (data != "error") {
              axios_symbol_list = data["data"]
          } else {
              axios_symbol_list = {"data":["BTCUSDT"]}
          }
          this.last_timestamp_get_symbol_list = new Date().getTime()
          this.symbol_list = axios_symbol_list
      }
    },
    // 指导symbol列合并单元格
    er_status_update_span_method: function(data) {
      this.guide_handle_span_col_0 = {}
      this.guide_handle_span_col_1 = {}

      var start = 0
      var count = 0
      for (var i = 1; i < data.length; i++) {
        var last = data[i - 1]
        var now = data[i]
        if (last[0]===now[0]) {
          count += 1
          this.guide_handle_span_col_0[start] = [count + 1, 1]
          this.guide_handle_span_col_0[i] = [0, 0]
        } else {
          start = i
          count = 0
        }
      }
      // 对第二列数据进行合并
      var start = 0
      var count = 0
      for (var i = 1; i < data.length; i++) {
        var last = data[i - 1]
        var now = data[i]
        if (last[0]===now[0] & last[1]===now[1]) {
          count += 1
          this.guide_handle_span_col_1[start] = [count + 1, 1]
          this.guide_handle_span_col_1[i] = [0, 0]
        } else {
          start = i
          count = 0
        }
      }
    },
    // 对状态页面的表格进行行合并，优化显示效果
    er_status_handle_span: function ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return this.guide_handle_span_col_0[rowIndex]
      } else if (columnIndex === 1) {
        return this.guide_handle_span_col_1[rowIndex]
      }
    },
    // 获取后端目前该预警ID所有记录的状态信息
    get_supervisor_strategy_msg: async function() {
      if (this.current_er_status_id == null) {
          return {}
      }
      var formData = new FormData();
      formData.append("mode", "get_supervisor_strategy_msg");
      formData.append("data", JSON.stringify({ "strategy_id": this.current_er_status_id }));
      let data = await this.$axios({
          url: this.$store.state.urlPort + "/early_report",
          method: "POST",
          data: formData,
        })
      return data
    },
    // 获取后端所有可以添加的预警指标信息(同时也是设置页面, 创建新预警时的标准，亦即：将所有默认设置项全部添加)
    get_all_early_report_indexs_settings: async function() {
      var formData = new FormData();
      formData.append("mode", "get_all_early_report_indexs_settings");
      let data = await this.$axios({
          url: this.$store.state.urlPort + "/early_report",
          method: "POST",
          data: formData,
        })
      return data
      // return {
      //   // 算法ID：算法名，算法默认指标(未添加UUID)
      //   "-2":["MA双均线", "-2_MA_66-490-3_f_all"],
      //   "-1":["GUPPY组", "-1_GUPPY_2-h_f_all"],
      //   //"0":["呼吸形态识别V1.0", "0_呼吸_2小时_f_buy"]
      // }
    },
    // 获取后端所有的相关预警记录
    get_all_early_report_data: async function (strategy_id = "all") {
      // 获取所有该登陆账户可以操作的策略详情
      var formData = new FormData();
      formData.append("mode", "get_strategys");
      formData.append("data", JSON.stringify({ "strategy_id": strategy_id }));
      let data = await this.$axios({
          url: this.$store.state.urlPort + "/early_report",
          method: "POST",
          data: formData,
        })
      return data["data"]
      // return [
      //     //"预警ID","名称", "标的池", "预警指标池", "状态"0为待启动，1为正在运行
      //     // 参数设置：id_name_param_t/f_param_uuid
      //     // 算法id, 算法名, 算法参数, 是否开启预警, 预警参数, 这条预警信息的uuid编号
      //     [0, "测试预警平台1",["BTCUSDT","ETHUSDT","BNBUSDT","DOTUSDT"], 
      //       ["-2_MA-1_66-490-3_f_all_08716b92-f710-4d66-a170-06f089f611e0",
      //        "-2_MA-2_83-520-3_t_all_08716b92-f710-4d66-a170-06f089f611e1",
      //        "-1_GUPPY-1_4-h_f_all_08716b92-f710-4d66-a170-06f089f611e3",
      //        "-1_GUPPY-2_2-h_t_all_08716b92-f710-4d66-a170-06f089f611e4",
      //        "0_呼吸-1_None_t_0.82_08716b92-f710-4d66-a170-06f089f611e5"],
      //     1
      //     ],
      //     [1, "测试预警平台2",["BTCUSDT","ETHUSDT","BNBUSDT"], 
      //       ["-2_MA-1_66-490-3_f_buy_08716b92-f710-4d66-a170-06f089f611e0",
      //        "-2_MA-2_83-520-3_t_all_08716b92-f710-4d66-a170-06f089f611e1",
      //        "-1_GUPPY-1_4-h_f_all_08716b92-f710-4d66-a170-06f089f611e3",
      //        "-1_GUPPY-2_2-h_t_sell_08716b92-f710-4d66-a170-06f089f611e4"],
      //     0
      //     ]
      //   ]
    },
    // 总览页面的初始化
    er_overview_init_table_func: function() {
      const name_array = this.er_overview_array;
      this.er_overview_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.er_overview_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }

      //this.er_overview_columns[0]["width"] = 100;
      this.er_overview_columns[2]["tooltip"] = true;
      this.er_overview_columns[3]["tooltip"] = true;
      this.er_overview_columns[4]["render"] = (h, params) => {
        var status_code = Number(this.er_overview_data[params["index"]][4])
        // 0 待运行 1 正在运行
        if (status_code == 0) {
          var disabled_style = [false, false, true, true]
        } else {
          var disabled_style = [true, true, false, false]
        }
        return h("div", [
          this.$createElement(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
                loading: this.er_overview_init_table_func_start_loading[params["index"]],
                disabled: disabled_style[0]
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: async () => {
                  this.$set(this.er_overview_init_table_func_start_loading, params["index"], true)
                  var value = this.er_overview_data[params["index"]]
                  var formData = new FormData();
                  formData.append("mode", "start_one_strategy");
                  formData.append("data", JSON.stringify({ 
                    "strategy_id": value[0],
                    "uuid":this.get_uuid()
                  }));
                  let data = await this.$axios({
                      url: this.$store.state.urlPort + "/early_report",
                      method: "POST",
                      data: formData,
                    })
                  if (data["status"] == false) {
                    this.$Message.error({
                      content: data["text"],
                      duration: 5,
                      background: true,
                    })
                  } else {
                    this.$Message.success({
                      content: data["text"],
                      duration: 2,
                      background: true,
                    })
                    this.er_overview_data[params["index"]][4] = "1"
                    
                    setTimeout(async () => {
                      this.all_early_report_data = await this.get_all_early_report_data()
                      this.update_early_report_table_msg()
                      await this.update_early_setting_table_msg()
                      this.$set(this.er_overview_init_table_func_start_loading, params["index"], false)
                    }, 3*1000);
                  }
                }
              },
            },
            "开启"
          ),
          this.$createElement(
            "Button",
            {
              props: {
                type: "warning",
                size: "small",
                loading: false,
                disabled: disabled_style[1]
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: async () => {
                  this.current_tabs_name = "name3"
                  this.er_setting_current_id = this.er_overview_data[params["index"]][0]
                  await this.update_early_setting_table_msg()
                }
              }
            },
            "设置"
          ),
          this.$createElement(
            "Button",
            {
              props: {
                type: "warning",
                size: "small",
                loading: false,
                disabled: disabled_style[2]
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: async () => {
                  this.current_tabs_name = "name2"
                  this.current_er_status_id = this.er_overview_data[params["index"]][0]
                  await this.update_early_status_table_msg()
                }
              }
            },
            "显示"
          ),
          this.$createElement(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
                loading: this.er_overview_init_table_func_stop_loading[params["index"]],
                disabled: disabled_style[3]
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: async () => {
                  this.$set(this.er_overview_init_table_func_stop_loading, params["index"], true)
                  var value = this.er_overview_data[params["index"]]
                  var formData = new FormData();
                  formData.append("mode", "end_one_strategy");
                  formData.append("data", JSON.stringify({ 
                    "strategy_id": value[0],
                    "uuid":this.get_uuid()
                  }));
                  let data = await this.$axios({
                      url: this.$store.state.urlPort + "/early_report",
                      method: "POST",
                      data: formData,
                    })
                  if (data["status"] == false) {
                    this.$Message.error({
                      content: data["text"],
                      duration: 5,
                      background: true,
                    })
                  } else {
                    this.$Message.success({
                      content: data["text"],
                      duration: 2,
                      background: true,
                    })
                    this.er_overview_data[params["index"]][4] = "0"
                    setTimeout(async () => {
                      this.all_early_report_data = await this.get_all_early_report_data()
                      this.update_early_report_table_msg()
                      await this.update_early_setting_table_msg()
                     this.$set(this.er_overview_init_table_func_stop_loading, params["index"], false)
                    }, 3*1000);
                  }
                }
              }
            },
            "关闭"
          )
        ]);
      };
      this.er_overview_columns[5]["render"] = (h, params) => {
        var status_code = Number(this.er_overview_data[params["index"]][4])
        var disabled_style = null
        // 0:待启动 1:正在运行
        if (status_code == 1) {
          disabled_style = true
        } else {
          disabled_style = false
        }
        return h("div",[
          this.$createElement(
            "Button",
            {
              props: {
                type: "text",
                loading: false,
                size:"large",
                shape:"circle",
                icon:"md-trash",
                disabled: disabled_style
              },
              style: {
                "font-size":"20px",
                "box-shadow":"none",
              },
              on: {
                click: async () => {
                  // 将预警策略从前端展示中直接删除
                  var value = this.er_overview_data[params["index"]]
                  var strategy_id = value[0]
                  this.$Modal.confirm({
                      title: '提示',
                      okText: '确定',
                      cancelText: '取消',
                      content: '此操作将删除 '+strategy_id+" 号策略,是否继续?",
                      onOk: async () => {
                          var formData = new FormData();
                          formData.append("mode", "delete_one_strategy");
                          formData.append("data", JSON.stringify({ 
                            "strategy_id": strategy_id,
                            "uuid":this.get_uuid()
                          }));
                          let data = await this.$axios({
                              url: this.$store.state.urlPort + "/early_report",
                              method: "POST",
                              data: formData,
                            })
                          if (data["status"] == true) {
                            this.$Message.success({
                              content: data["text"],
                              duration: 3,
                              background: true,
                            })
                            setTimeout(async () => {
                              this.loop_update_er_overview_click()
                            }, 0);
                          } else {
                            this.$Message.error({
                              content: data["text"],
                              duration: 3,
                              background: true,
                            })
                          }
                      },
                      onCancel: () => {
                        this.$Message.success({
                          content: "已取消本次操作",
                          duration: 2,
                          background: true,
                        })
                      }
                  })
                }
              },
            }
          )
        ]);
      };

    },
    // 当前预警状态初始化
    er_status_init_table_func: function() {
      const name_array = this.er_status_array;
      this.er_status_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        if (i === 0) {
          // 为"标的"列添加筛选方法
          this.er_status_columns.push({
            title: name_array[i],
            key: name_array[i],
            align: "center",
            filters:[],
            filterMethod:(value, row) => {
                return row["标的"] == value || row["标的"] == value + "_defalut"
            }
          });
        } else {
          this.er_status_columns.push({
            title: name_array[i],
            key: name_array[i],
            align: "center"
          });
        }
      }
      //this.er_status_columns[0]["width"] = 100;
      //this.er_status_columns[1]["tooltip"] = true;
      //this.er_status_columns[2]["tooltip"] = true;
      
      this.er_status_columns[0]["render"] = (h, params) => {
        var value = this.er_status_data[params["index"]][0]
        if (value.indexOf("_defalut") != -1) {value = ""}
        return h("div", [
          h(
            "span",
            {
              style: {
                //color: "blue"
              }
            },
            value
          )
        ]);
      }
      //this.er_status_columns[3]["tooltip"] = true;
      this.er_status_columns[3]["render"] = (h, params) => {
        var value = this.er_status_data[params["index"]][3]
        if (this.er_status_data[params["index"]][1] == "币安数据") {
          if (value.toString().indexOf("-") != -1) {
            var _color = "#006633";
          } else {
            var _color = "#ed4014";
          }
          return h("div", [
            h(render_table_view,{
                props: {
                  _type:1,
                  binance_data:value,
                  dingding_color:'#808695'
                },
              },
            )
          ]);
        } else {
          if (value.toString().indexOf("Buy") != -1) {
            var _color = "#006633";
          } else if (value.toString().indexOf("Sell") != -1){
            var _color = "#ed4014";
          } else {
            var _color = "#996600";
          }
          return h("div", [
            h(
              "span",
              {
                style: {
                  color: _color
                }
              },
              value
            )
          ]);
        }
      }
    },
    // 设置页面初始化
    er_setting_2_init_table_func: function() {
      const name_array = this.er_setting_2_array;
      this.er_setting_2_columns = [];
      for (var i = 0; i < name_array.length; i++) {
          this.er_setting_2_columns.push({
            title: name_array[i],
            key: name_array[i],
            align: "center"
          })
      }
      this.er_setting_2_columns[0]["minwidth"] = 50;
      this.er_setting_2_columns[1]["render"] = (h, params) => {
        var value = this.er_setting_2_data[params["index"]][1]
        if (value.toString().toUpperCase().indexOf("NONE") != -1) {value = ""}
        return h("div", [
          h(
            "span",
            {
              style: {
                //color: "blue"
              }
            },
            value
          )
        ]);
      }
      this.er_setting_2_columns[2]["render"] = (h, params) => {
        var value = this.er_setting_2_data[params["index"]][2]
        var _id = value.split("_")[0].toString()
        var paras = value.split("_")[2].split("-")

        var _myclick = () => {
          var value = this.er_setting_2_data[params["index"]]
          this.modal_view_msg.modal_type = "setting_msg"
          this.modal_view_msg.uuid = value[2].split("_")[5]
          this.modal_view_msg.paras = value[2].split("_")

          this.modal_view_msg.open_modal_switch = true
        }
        var color = "#886600"
        var dingding_switch = value.split("_")[3]
        var dingding_paras = value.split("_")[4].toUpperCase()
        var dingding_color = dingding_switch == "t"?"#2b85e4":"black"
        var dingding_icon = dingding_switch == "t"?"ios-alarm":"ios-alarm-outline"

        if (_id == "-2") {
          return h("div", [
            h(render_table_view,{
                props: {
                  columns: [
                    {"title":"MA参数", "data":paras.join(" "), "color":color},
                  ],
                  dingding_text:dingding_paras,
                  dingding_color:dingding_color,
                  dingding_icon:dingding_icon
                },
                on:{
                  myclick:_myclick
                }
              },
            )
          ]);
        } else if (_id == "-1") {
          return h("div", [
            h(render_table_view,{
                props: {
                  columns: [
                    {"title":"GUPPY回顾时间", "data":paras[0] + paras[1], "color":color},
                  ],
                  dingding_text:dingding_paras,
                  dingding_color:dingding_color,
                  dingding_icon:dingding_icon
                },
                on:{
                  myclick:_myclick
                }
              },
            )
          ]);
        } else if (_id == "-3") {
          return h("div", [
            h(render_table_view,{
                props: {
                  columns: [
                    {"title":"占位参数，无实际意义", "data":paras[0], "color":color},
                  ],
                  dingding_text:dingding_paras,
                  dingding_color:dingding_color,
                  dingding_icon:dingding_icon
                },
                on:{
                  myclick:_myclick
                }
              },
            )
          ]);
        }
      }
      this.er_setting_2_columns[3]["render"] = (h, params) => {
        return h("div", [
          this.$createElement(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
                loading: false,
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: () => {
                  var value = this.er_setting_2_data[params["index"]]
                  this.modal_view_msg.modal_type = "setting_msg"
                  this.modal_view_msg.uuid = value[2].split("_")[5]
                  this.modal_view_msg.paras = value[2].split("_")

                  this.modal_view_msg.open_modal_switch = true
                }
              },
            },
            "设置"
          ),
          this.$createElement(
            "Button",
            {
              props: {
                type: "warning",
                size: "small",
                loading: false
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: () => {
                  this.er_setting_2_data.splice(params["index"], 1)
                }
              }
            },
            "删除"
          )
        ]);
      }

    },
    // 预警总览页面更新按钮
    loop_update_er_overview_click: function() {
      // 刷新按钮被单击，刷新一次所有策略
      this.loop_update_er_overview_loading = true
      setTimeout(async () => {
        this.all_early_report_data = await this.get_all_early_report_data()
        this.update_early_report_table_msg()
        this.loop_update_er_overview_loading = false
      }, 800);
    },
    // 当前预警状态更新按钮
    loop_update_current_er_status_click: function() {
      if (this.loop_update_current_er_status_loading == true) {
        return null
      }
      this.loop_update_current_er_status_loading = true
      setTimeout(async () => {
        await this.update_early_status_table_msg()
        this.loop_update_current_er_status_loading = false
      }, 1000);
    },
    // 更换预警状态所监控的ID按钮(mode 0)
    // 向设置页面table下添加一条新的记录(mode 1)
    early_report_render_dropdown_click: async function(value) {
      if (value["mode"] == "ok") {
        if (value["type"] == 0) {
          this.current_er_status_id = value["id"]
          this.loop_update_current_er_status_click()
          localStorage.setItem(this.prefix + "current_er_status_id", this.current_er_status_id)
        } else if (value["type"] == 1) {
          var key = value["id"]
          var name = this.all_index[key][1].split("_")[1]
          this.er_setting_2_data.push([
            this.all_index[key][0], name, this.all_index[key][1] + "_" + this.get_uuid(), key
          ])
        }
      } else {
        console.log("early_report_render_dropdown_click返回的状态不为ok")
      }
    },
    // 设置界面穿梭框出现改动后调用
    er_setting_1_change: function(new_target_keys) {
      this.er_setting_1_target_keys = new_target_keys
    },
    // 设置页面--穿梭框的搜索函数
    er_setting_1_filter_method: function(data, query) {
      if (data.label.toString().indexOf(query) != -1 ) {
        return true
      } else if (data.label.toString().indexOf(query.toUpperCase()) != -1) {
        return true
      } else {
        return false
      }
    },
    // 设置页面--单击录入ID按钮
    er_setting_2_button_load_id: function() {
      this.modal_view_msg.modal_type = "select_early_report_msg"
      this.modal_view_msg.uuid = ""
      this.modal_view_msg.paras = JSON.parse(JSON.stringify(this.all_early_report_data))
      
      this.modal_view_msg.open_modal_switch = true
    },
    // 设置页面--单击创建/提交按钮
    er_setting_2_button_submit: async function() {
      if (this.er_setting_1_target_keys.length == 0) {
          this.$Message.warning({
            content: "预警标的池不允许为空",
            duration: 2,
            background: true,
          })
          return null
        }
      if (this.er_setting_current_id.toString() == "-1") {
        // 创建新的预警
        this.modal_view_msg.modal_type = "create_or_alter_strategy"
        this.modal_view_msg.paras = ["", this.er_setting_current_id]
        this.modal_view_msg.open_modal_switch = true
      } else {
        // 修改既有预警
        this.modal_view_msg.modal_type = "create_or_alter_strategy"
        var name = ""
        for (var i in this.er_overview_data) {
          if (this.er_overview_data[i][0].toString() == this.er_setting_current_id.toString()) {
            name = this.er_overview_data[i][1]
            break
          }
        }
        this.modal_view_msg.paras = [name, this.er_setting_current_id]
        this.modal_view_msg.open_modal_switch = true
      }
    },
    // 设置页面model被单击
    modal_click:async function(value) {
      if (value["mode"] != "ok") {
        this.modal_view_msg["open_modal_switch"] = false
        return null
      }
      if (value["m_type"] === "select_early_report_msg") {
        // 用户修改了设置的ID
        this.er_setting_current_id = value["select_early_report"]["id"]
        await this.update_early_setting_table_msg()
        this.$Message.success('success')
      } else if (value["m_type"] === "setting_msg") {
        for (var i in this.er_setting_2_data) {
          var tmp = this.er_setting_2_data[i]
          var uuid = tmp[2].split("_")[5]
          if (uuid === value["uuid"] ) {
            this.$set(this.er_setting_2_data[i], 2, value["paras"].join("_"))
            this.$set(this.er_setting_2_data[i], 1, value["paras"][1])
            break
          }
        }
        this.$Message.success('success')
      } else if (value["m_type"] === "create_or_alter_strategy") {
        var formData = new FormData();
        let tmp_data = {
          "strategy_name": value["paras"][0],
          "symbols": this.er_setting_1_target_keys,
          "id":this.er_setting_current_id
        }
        if (this.er_setting_current_id.toString() == "-1") {
          formData.append("mode", "create_one_strategy")
        } else {
          formData.append("mode", "alter_one_strategy")
          tmp_data["mode"] = 0
          tmp_data["status"] = 0
        }
        var indexs = []
        for (var i in this.er_setting_2_data) {
          indexs.push(this.er_setting_2_data[i][2])
        }
        tmp_data["indexs"] = indexs
        formData.append("data", JSON.stringify(tmp_data))
        let data = await this.$axios({
            url: this.$store.state.urlPort + "/early_report",
            method: "POST",
            data: formData,
          })
        if (data["status"] == false) {
          this.$Message.error({
            content: data["text"],
            duration: 5,
            background: true,
          })
        } else {
          this.$Message.success({
            content: data["text"],
            duration: 2,
            background: true,
          })
        }
      }
      this.modal_view_msg["open_modal_switch"] = false
    },
    get_uuid: function() {
      var d = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random()*16)%16 | 0;
        d = Math.floor(d/16);
        return (c=='x' ? r : (r&0x3|0x8)).toString(16);
      });
      return "ear-" + uuid;
    },
    init_web: async function() {
      // 初始化页面时调用
      // 设计初主要用于对上次页面位置的记录, 下次退出登陆尽量保持原样
      var local_save_key = [
        "current_tabs_name", "current_er_status_id",
        "er_setting_current_id"
      ]
      for (var i in local_save_key) {
        var data = localStorage.getItem(this.prefix + local_save_key[i])
        if (data != null && data != undefined) {
          this[local_save_key[i]] = data
          if (local_save_key[i] === "current_er_status_id") {
            this.loop_update_current_er_status_click()
          } else if (local_save_key[i] === "er_setting_current_id") {
            await this.update_early_setting_table_msg()
          }
        }
      }
    },
  },
  mounted: async function() {
    setTimeout(async () => {
        this.all_early_report_data = await this.get_all_early_report_data()
        this.all_index = await this.get_all_early_report_indexs_settings()
        this.update_early_report_table_msg()
        await this.update_early_setting_table_msg()
      }, 0);
    await this.init_web()
  },
  watch: {
    current_tabs_name(new_value, old_value) {
      localStorage.setItem(this.prefix + "current_tabs_name", new_value)
      if (new_value == "name1") {
        setTimeout(async () => {
          this.all_early_report_data = await this.get_all_early_report_data()
          this.update_early_report_table_msg()
          await this.update_early_setting_table_msg()
        }, 0);
      } else if(new_value == "name2") {
        setTimeout(async () => {
          this.loop_update_current_er_status_click()
        }, 0);
      }
    },
    er_setting_current_id(new_value, old_value) {
      if (new_value.toString() == "-1") {
        this.er_setting_title = "创建新的预警"
        this.er_setting_2_button_submit_text = "确认创建"
      } else {
        this.er_setting_title = "修改" + new_value + "号预警"
        this.er_setting_2_button_submit_text = "确认修改"
      }
      localStorage.setItem(this.prefix + "er_setting_current_id", new_value)
    }
  },
  created: function() {
    clearInterval(this.timer);
    this.timer = null;
    // 5分钟一刷新
    this.setTimer(5 * 60 * 1000);
  },
  destroyed: function()  {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<style scoped>
.header-collapse {
  background-color: rgba(255, 255, 255, 0.2);
}
</style>